export default __webpack_public_path__ + "static/media/compra.4807b791.png";